module.exports = __webpack_public_path__ + "static/media/technology.d4b92958.png";